import React from "react";
import LeaguesList from "../../Leagues/LeaguesList";

const Leagues = () => {
  return (
    <>
      <div className={"mb-2"}>
        <LeaguesList />
      </div>
    </>
  );
};

export default Leagues;
